import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IOnHandEntry, IOnHand } from "../models/onHandDelivery";
import { throwApiError } from "./apiError";

/**
 * CRETE API call using Axios
 * @returns - Create ON Hand and return same object
 */

export const CreateOnHandEntryAPI = async (params: IOnHandEntry): Promise<IOnHand> => {
  try {
    const response = await axios.post(getUrl(ApiType.ON_HAND_ENTRY_CREATE), params);
    return response.data;
  } catch (error: any) {
    return throwApiError(error, ErrorMessages.createOnHandEntry, { badRequestOrder: "errorsFirst" });
  }
};
